import * as React from 'react';

import {
  NavigationProps,
} from './topnavgationprops';

/**
 * Top Navigation  displayed to top left of the header
 * @children is passed in props with JSX element
 */
export const TopNavigation: any = (
  props: NavigationProps
) => {
  const {
    children
  } = props;
  return (
    <div className="top-navigation">
      <div className="top-navigation__list">
        {children}
      </div>
    </div>
  )
};
